import { z } from "zod";
import { EmailSchema, IdSchema, PasswordSchema, PersonNameSchema } from "../common/primitives.js";
import { PermissionSchema, RoleSchema } from "./permissions.js";
export const SignInRequestSchema = z.object({
    email: EmailSchema,
    password: z.string().min(1, "Password is required").max(128),
});
export const CurrentUserSchema = z.object({
    id: IdSchema,
    name: PersonNameSchema,
    email: EmailSchema,
    role: RoleSchema,
    mustChangePassword: z.boolean(),
    /** The admin requires this person to ask before buying (D-47). Always false for admins. */
    requiresPurchaseApproval: z.boolean(),
});
/** GET /api/v1/me */
export const MeResponseSchema = z.object({
    user: CurrentUserSchema,
    permissions: z.array(PermissionSchema),
});
/** POST /api/v1/me/password */
export const ChangePasswordRequestSchema = z
    .object({
    currentPassword: z.string().min(1, "Current password is required").max(128),
    newPassword: PasswordSchema,
})
    .refine((v) => v.newPassword !== v.currentPassword, {
    path: ["newPassword"],
    message: "New password must be different from the current password",
});
//# sourceMappingURL=session.js.map